import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSitemap, faProjectDiagram, faFloppyDisk, faSpinner,
  faRocket, faRotateRight, faStop,
} from '@fortawesome/free-solid-svg-icons';
import './FloatingViewerButtons.css';

// Fixed circular shortcuts (bottom-right) to reopen the sample Design Document
// and Threat Model viewers, plus optional "Save All" and server-control
// shortcuts above them. Expand on hover/focus to reveal their label.
function FloatingViewerButtons({
  onOpenDesignDoc, onOpenThreatModel,
  onSaveAll, savingAll, saveAllDisabled,
  onStartOrRestart, serverRunning, serverLoading,
  onStop, stopDisabled,
}) {
  return (
    <div className="floating-viewer-buttons">
      {onStartOrRestart && (
        <button
          id="fvb-start-restart"
          type="button"
          className="floating-viewer-btn floating-viewer-btn--amber"
          onClick={onStartOrRestart}
          disabled={serverLoading}
        >
          <span className="fvb-icon">
            <FontAwesomeIcon icon={serverLoading ? faSpinner : (serverRunning ? faRotateRight : faRocket)} spin={serverLoading} />
          </span>
          <span className="fvb-label">
            {serverRunning ? (serverLoading ? 'Restarting…' : 'Restart Server') : (serverLoading ? 'Starting Server…' : 'Start Pentest Server')}
          </span>
        </button>
      )}
      {onStop && (
        <button
          id="fvb-stop"
          type="button"
          className="floating-viewer-btn floating-viewer-btn--red"
          onClick={onStop}
          disabled={stopDisabled}
        >
          <span className="fvb-icon"><FontAwesomeIcon icon={stopDisabled ? faSpinner : faStop} spin={stopDisabled} /></span>
          <span className="fvb-label">{stopDisabled ? 'Stopping…' : 'Stop Server'}</span>
        </button>
      )}
      {onSaveAll && (
        <button
          id="fvb-save-all"
          type="button"
          className="floating-viewer-btn floating-viewer-btn--slate"
          onClick={onSaveAll}
          disabled={savingAll || saveAllDisabled}
        >
          <span className="fvb-icon">
            <FontAwesomeIcon icon={savingAll ? faSpinner : faFloppyDisk} spin={savingAll} />
          </span>
          <span className="fvb-label">{savingAll ? 'Saving…' : 'Save All Findings'}</span>
        </button>
      )}
      {onOpenDesignDoc && (
        <button
          id="fvb-design-doc"
          type="button"
          className="floating-viewer-btn floating-viewer-btn--indigo"
          onClick={onOpenDesignDoc}
        >
          <span className="fvb-icon"><FontAwesomeIcon icon={faSitemap} /></span>
          <span className="fvb-label">Open Design Document Viewer</span>
        </button>
      )}
      {onOpenThreatModel && (
        <button
          id="fvb-threat-model"
          type="button"
          className="floating-viewer-btn floating-viewer-btn--green"
          onClick={onOpenThreatModel}
        >
          <span className="fvb-icon"><FontAwesomeIcon icon={faProjectDiagram} /></span>
          <span className="fvb-label">Open Threat Model Viewer</span>
        </button>
      )}
    </div>
  );
}

export default FloatingViewerButtons;
